export default __webpack_public_path__ + "static/IMG_0701-f17af53706b3fd45888b963c8961ed79.jpg";